import {Action, Selector, State, StateContext} from "@ngxs/store";

export class TitleStateModel {
  title:string;
}

export class SetTitle {
  static readonly type = '[title] SetTitle';
  constructor (public title:string) {}
}

@State<TitleStateModel>({
  name: 'title',
  defaults: {
    title: ""
  }
})
export class TitleState{

  constructor() {
  }

  @Selector()
  public static title(state: TitleStateModel){
    return state.title;
  }

  @Action(SetTitle)
  setDecision(ctx:StateContext<TitleStateModel>, action: SetTitle){
    ctx.patchState({title: action.title});
  }

}
